export const CV_FIELDSET_KEY_MAP = {
  0: 'add_later',
  1: 'upload_cv',
  2: 'linkedin_profile_link',
  3: 'work_experiences'
};

export const CV_FIELDSET_INITIAL_VALUES = {
  work_experiences: [],
  linkedin_profile_link: ''
};

export const KEYS_TO_STORE = ['linkedin_profile_link', 'work_experiences'];
